import styled from "styled-components";

export const StyledSimpleTableWithPaginator = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;